import { Button, DatePicker, message, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { serverFetch } from "@server";
import { fmtDateTimeFull } from "@extensions/utils";
import { strDate2Server } from "@extensions/convert";
import { refreshButton } from "@extensions/design";
import { tokenVidsLabel, messageStatusesRender, messageDirectionsRender } from "@extensions/enums";
import dayjs from "dayjs";
import MessagesItem from "./messages-item";

const MessagesList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(dayjs().startOf('month'));
  const [dateTo, setDateTo] = useState(dayjs().endOf('day'));
  const [sendModalVisible, setSendModalVisible] = useState(false);
  const tableWrapRef = useRef(null);
  const [tableScrollY, setTableScrollY] = useState(300);

  const getData = () => {
    setLoading(true);
    
    serverFetch(`message?dateFrom=${strDate2Server(dateFrom)}&dateTo=${strDate2Server(dateTo)}`)
      .then((data) => {
        setLoading(false);
        setItems(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    getData();
  }, [dateFrom, dateTo]);

  useEffect(() => {
    const updateTableHeight = () => {
      const top = tableWrapRef.current?.getBoundingClientRect?.().top ?? 0;
      // Reserve extra bottom space for container paddings/scrollbar so table never overflows viewport.
      const viewportHeight = Math.min(window.innerHeight, document.documentElement.clientHeight);
      const next = Math.max(200, viewportHeight - top - 32);
      setTableScrollY(next);
    };

    updateTableHeight();
    window.addEventListener("resize", updateTableHeight);
    return () => window.removeEventListener("resize", updateTableHeight);
  }, []);

  const handleSendMessage = () => {
    setSendModalVisible(true);
  };

  const columns = [
    { dataIndex: "id", title: "#", width: 80 },
    { dataIndex: "createdOn", title: "Дата создания", width: 180, render: fmtDateTimeFull },
    { dataIndex: "direction", title: "Направление", width: 120, render: messageDirectionsRender },
    { dataIndex: "phone", title: "Телефон", width: 150 },
    { dataIndex: "body", title: "Сообщение", width: 300 },
    { dataIndex: "vid", title: "Вид", width: 120, render: tokenVidsLabel },
    { dataIndex: "status", title: "Статус", width: 150, render: messageStatusesRender },
    { dataIndex: "errText", title: "Ошибка", ellipsis: true },
    { dataIndex: "externalId", title: "Внешний #", width: 120 },
  ];

  return (
    <>
      <div className="page-cloud-row">
        <div>
          <div>Период с</div>
          <DatePicker value={dateFrom} onChange={(e) => setDateFrom(e)} format="DD.MM.YYYY" allowClear={false} style={{ width: 150 }} />
        </div>
        <div>
          <div>по</div>
          <DatePicker value={dateTo} onChange={(e) => setDateTo(e)} format="DD.MM.YYYY" allowClear={false} style={{ width: 150 }} />
        </div>
        <Button type="primary" onClick={handleSendMessage} disabled={loading}>Отправить</Button>
        {refreshButton(getData)}
      </div>      
      <div ref={tableWrapRef}>
        <Table
          columns={columns}
          dataSource={items}
          loading={loading}
          rowKey="id"
          pagination={false}
          size="small"
          scroll={{ x: "max-content", y: tableScrollY }}
        />
      </div>
      {sendModalVisible && <MessagesItem onClose={() => setSendModalVisible(false)} onSuccess={getData} />}
    </>
  );
};

export default MessagesList;